<div class="chart-container">
  <div class="row">
    <div class="col-12">
      <!-- Skeleton loader -->
      <div *ngIf="isLoading" class="chart-skeleton">
        <div class="skeleton-title"></div>
        <div class="skeleton-bars">
          <div class="skeleton-bar" *ngFor="let i of [1,2,3,4,5,6,7,8,9,10,11,12]"></div>
        </div>
        <div class="skeleton-axis"></div>
      </div>
      
      <!-- Gráfico real -->
      <apx-chart
        *ngIf="chartOptions && !isLoading"
        [series]="chartOptions.series"
        [chart]="chartOptions.chart"
        [xaxis]="chartOptions.xaxis"
        [dataLabels]="chartOptions.dataLabels"
        [tooltip]="chartOptions.tooltip"
        [title]="chartOptions.title"
        [colors]="chartOptions.colors">
      </apx-chart>
    </div>
  </div>
</div>
